import React from 'react';
import { Card, CardContent, Skeleton, Box, Grid } from '@mui/material';

const CurrencySkeleton = () => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Skeleton variant="circular" width={36} height={36} />
            <Box>
              <Skeleton variant="text" width={70} height={20} />
              <Skeleton variant="text" width={40} height={14} />
            </Box>
          </Box>
          <Skeleton variant="rectangular" width={45} height={22} sx={{ borderRadius: 1 }} />
        </Box>
        <Grid container spacing={1} sx={{ pt: 1, borderTop: '1px solid', borderColor: 'divider' }}>
          <Grid item xs={6}>
            <Skeleton variant="text" width={30} height={14} />
            <Skeleton variant="text" width={60} height={22} />
          </Grid>
          <Grid item xs={6} sx={{ textAlign: 'right' }}>
            <Skeleton variant="text" width={30} height={14} sx={{ ml: 'auto' }} />
            <Skeleton variant="text" width={60} height={22} sx={{ ml: 'auto' }} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CurrencySkeleton;
